import React, { useState } from 'react';

const ProductCard = ({ product, onViewDetails }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  return (
    <div className="product-card" style={{ position: 'relative' }}>
      {/* Image with lazy loading */}
      <div 
        className="product-image"
        style={{ 
          height: '300px',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: '12px 12px 0 0',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Loading placeholder */}
        {!imageLoaded && !imageError && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'var(--gold-light)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div className="loading-spinner"></div>
          </div>
        )}
        
        {/* Error fallback */}
        {imageError && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'var(--light-gray)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--gray)'
          }}>
            <i className="fas fa-image" style={{ fontSize: '2rem', marginBottom: '10px' }}></i>
            <span>Image not available</span>
          </div>
        )}
        
        {/* Actual image */}
        <img
          src={product.image}
          alt={product.title}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageError(true)}
          loading="lazy"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: imageLoaded ? 1 : 0,
            transition: 'opacity 0.3s ease'
          }}
        />
      </div>
      
      <div className="product-content" style={{ padding: '24px' }}>
        <h3 style={{ fontSize: '24px', marginBottom: '8px' }}>{product.title}</h3>
        
        <div className="product-specs" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
          gap: '12px',
          margin: '16px 0'
        }}>
          {product.specs.map((spec, idx) => (
            <div key={idx} className="spec" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '14px',
              color: 'var(--gray)'
            }}>
              <i className={spec.icon}></i> {spec.text}
            </div>
          ))}
        </div>
        
        <p className="description" style={{
          fontSize: '14px',
          lineHeight: '1.6',
          color: 'var(--gray)',
          margin: '16px 0',
          minHeight: '70px'
        }}>
          {product.description}
        </p>
      </div>
    </div>
  );
};

export default ProductCard;